<template>
    <div id="input-name-slug">
        <div class="md-form mt-1 mb-0">
            <i class="material-icons prefix">title</i>
            <input type="text"
                   :id="input_name__id"
                   :name="input_name__name"
                   v-model="input_name__value"
                   :readonly="input_name__disabled == 1"
                   v-on:input="testSlug(true)"
                   class="form-control"
                   required
                   aria-required="true"
                   autocomplete="off">

            <label :for="input_name__id" :class="input_name__active"
                   data-error="wrong" data-right="correct">Name</label>
        </div>
        <div class="md-form mt-1 mb-0">
            <i class="material-icons prefix">insert_link</i>
            <input type="text"
                   :id="input_slug__id"
                   :name="input_slug__name"
                   v-model="input_slug__value"
                   :readonly="input_slug__disabled == 1"
                   class="form-control"
                   @change="testSlug(false)"
                   required
                   aria-required="true"
                   autocomplete="off">

            <label :for="input_slug__id" class="active"
                   :class="input_slug__active"
                   data-error="wrong" data-right="correct">Slug</label>
        </div>
    </div>
</template>

<script>
    import {urlFormat} from '../../urlFormat';
    import {GOOGLEMAPS_API_KEY, NAME_TO_SLUG_UPDATE} from '../../config';
    import {setLabelErrorByInputId, setLabelActiveByInputId} from '../../helpers/forms'
    import {debounce} from 'underscore';
    import axios from 'axios';

    require('underscore');

    /**
     * Converts any input from the name tag to a url friendly slug
     *
     * @author keni williams
     */
    component: {
        axios
    }
    export default {
        props: ['content'],
        mounted: function () {
            let theContent = this.content;
            if (!theContent) {
//				console.log('this.$parent',this.$parent.$options.propsData.content);
                if ('content' in this.$parent.$options.propsData) {
                    theContent = this.$parent.$options.propsData.content;
                }
                else {
                    return false;
                }

            }
            /**
             * Test if slug checker has been fullfilled
             * */
            if (typeof theContent['slug_check__url'] !== 'undefined' && typeof theContent['input_slug__owner'] !== 'undefined') {
                this.slug_check__url = theContent['slug_check__url'];
                this.input_slug__owner = theContent['input_slug__owner'];
            }
            else {
                this.disableAll;
                throw new Error('slug_check__url or input_slug__owner has not been set. Check the element content that is initialising slug_to_name or input_slug__owner and include  slug_check__url with the value of the route and input_slug__owner has beed defined');
            }
            if (typeof theContent['slug_check__client'] !== 'undefined' && typeof theContent['slug_check__client'] !== 'undefined') {

                this.slug_check__client = theContent['slug_check__client'];

            }
//			console.log('this.content',theContent);

            /**
             *
             * @type {[string,string,string,string]}
             */
            let loop = ['id', 'value', 'name', 'disabled'];

            for (let i = 0; i < loop.length; ++i) {

                if (`input_name__${loop[i]}` in theContent) {
                    this[`input_name__${loop[i]}`] = (loop[i] === 'disabled') ? (theContent[`input_name__${loop[i]}`] !== '') : theContent[`input_name__${loop[i]}`];
                }

                if (`input_slug__${loop[i]}` in theContent) {
                    this[`input_slug__${loop[i]}`] = (loop[i] === 'disabled') ? (theContent[`input_slug__${loop[i]}`] !== '') : theContent[`input_slug__${loop[i]}`];
                }
            }

            // disable the slug if it has already been set
            if (this.input_name__value.length > 0) {
                this.input_slug__disabled = 1;
            }
        },
        watch: {
            input_name__value: function (value) {
//				console.log('value', value);
            }
        },
        data() {
            return {
                input_name__id: 'name_slug_name__id',
                input_slug__id: 'name_slug_slug__id',
                input_name__active: false,
                input_slug__active: false,

                input_name__name: '',
                input_name__value: '',
                input_name__disabled: '',

                input_slug__name: '',
                input_slug__value: '',
                input_slug__disabled: '',

                slug_check__url: '',
                slug_check__client: false,
                input_slug__owner: '',
                stop_execution__handler: false,
                debouncing: false,
                wasSlug:false
            }
        },
        created: function () {
            vueEventHub.$on(NAME_TO_SLUG_UPDATE, this.updateName);

        },
        methods: {
            disableAll() {
                this.stop_execution__handler = true;
                this.input_slug__disabled = 1;
                this.input_name__disabled = 1;
            },
            /**
             * recieves any broadcasted event matching the NAME_TO_SLUG_UPDATE bus
             * @param nameObject is object text:'string'
             */
            updateName: function (nameObject) {
//				console.log('this.input_slug__value',this.input_slug__value);
                if (this.stop_execution__handler) {
                    return;
                }
                if (this.input_slug__disabled > 0) {

                    return;
                }
                this.input_name__value = nameObject.text;
                this.input_name__active = 'active';

                this.testSlug(true);
            },
            testSlug(input) {
                let _this = this;
                if (this.input_slug__disabled > 0) {
                    return;
                }
                if (this.debouncing !== true) {
                    this.debouncing = true;
                    toastr.info('Testing if slug has already been used');
                }
                // console.log('input',input);
                if (input === true) {
                    this.inputChanged();
                } else {
                    _this.wasSlug  = true;
                    this.slugChanged();
                }
            },
            /**
             * Updates the slug after debouncing and checking
             */
            slugChanged: debounce(function (e) {

                // console.log('slugChanged');
                let inputTest = '',
                    slug = '',
                    _this = this,
                    formattedSlug;
                if(!_this.wasSlug){
                    return;
                }

                formattedSlug = urlFormat(this.input_slug__value, {
                    alphaNumeric: true,
                    stripLastHyphen: true
                });
                _this.updateSlug(formattedSlug);
                _this.debouncing = false;
            }, 3000),
            /**
             * Creates slug based on the input field
             */
            inputChanged: debounce(function (e) {
                // console.log('inputChanged');
                // console.log('creating');
                let inputTest = '',
                    slug = '',
                    _this = this,
                    formattedSlug;

                // if the input is blank then pre-fill it with the slug value
                if (this.input_name__value.length <= 0) {
                    //set the input
                    inputTest = _this.input_slug__value;
                }
                else {
                    inputTest = urlFormat(this.input_name__value, {
                        delimiter: ' ',
                        toLower: false,
                        alphaChar: false,
                        alphaNumeric: false
                    });
                    _this.input_name__value = inputTest;
                    console.log('inputTest', inputTest);

                }

                formattedSlug = urlFormat(inputTest, {
                    alphaNumeric: true,
                    stripLastHyphen: true
                });
                // console.log('formattedSlug', formattedSlug);
                _this.updateSlug(formattedSlug);
                _this.debouncing = false;
                _this.wasSlug = false;
            }, 3000),

            updateSlug(formattedSlug) {
                let _this = this;
                axios({
                    method: 'get',
                    url: _this.slug_check__url,
                    params: {
                        slug: formattedSlug,
                        owner: _this.input_slug__owner,
                        slug_check__client: _this.slug_check__client
                    }
                }).then((response) => {
                    if (response.status !== 200) {
                        _this.disableAll();
                    }
                    if (response.data.has_duplicate) {
                        setLabelErrorByInputId(_this.input_slug__id);
                        toastr.error('Slug already used. I have set to ' + response.data.slug + ' as a suggestion');
                    }
                    else {
                        setLabelActiveByInputId(_this.input_slug__id);
                        toastr.success('Yay! this slug ' + response.data.slug + ' is unique! 😄');
                    }

                    _this.input_slug__value = response.data.slug;
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/NameToSlug.vue?0cf389ae